/** Apenas dígitos. */
export function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '')
}

/**
 * Normaliza para armazenamento/envio WhatsApp: 55 + DDD + número (12–13 dígitos).
 */
export function normalizeBrazilPhoneForStorage(raw) {
  let d = digitsOnly(raw)
  if (!d) return ''
  if (d.startsWith('55') && d.length >= 12 && d.length <= 13) return d
  if (d.length === 10 || d.length === 11) return `55${d}`
  if ((d.length === 12 || d.length === 13) && !d.startsWith('55')) return `55${d}`
  return d
}

/**
 * Formata para exibição: (11) 99999-9999
 */
export function formatBrazilPhoneForDisplay(stored) {
  let d = digitsOnly(stored)
  if (!d) return ''
  if (d.startsWith('55') && d.length > 11) d = d.slice(2)
  if (d.length > 11) d = d.slice(-11)
  if (d.length <= 2) return d.length ? `(${d}` : ''
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7, 11)}`
}

/**
 * Aplica máscara durante digitação (máx. 11 dígitos locais, sem código do país no campo).
 */
export function maskBrazilPhoneInput(rawDigits) {
  let d = digitsOnly(rawDigits)
  if (d.startsWith('55') && d.length > 11) d = d.slice(2)
  d = d.slice(0, 11)
  return formatBrazilPhoneForDisplay(d)
}
